<template>
  <div class="main-container NewReport">
    <div class="bread">
      <router-link :to="{ name: 'MemberTest' }">我的考试</router-link>
      <span class="slash">/</span>
      <span class="current">{{ testInfo.name }}</span>
    </div>
    <div class="main-content">
      <div class="test-info-content">
        <div class="test-title" :title="testInfo.name">
          {{ testInfo.name }}
        </div>
        <div class="subjective">
          <template v-if="testInfo.subjective">
            <img src="../../images/member/introduce.png" />
            <span>{{ testInfo.subjective }}</span>
          </template>
        </div>
        <div class="paper-detail">
          <div style="margin-right: 48px">
            <label>交卷时间：</label>
            <span>{{ testInfo.submit_time }}</span>
          </div>
          <div style="margin-right: 40px">
            <label>作答时长：</label>
            <span>{{ testInfo.answer_time }}</span>
          </div>
          <div class="record-link" @click="showRecord" v-if="recordList && recordList.length > 1">
            考试记录 >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewReport',
  components: {},
  data() {
    return {
      testInfo: {},
      id: this.$route.query.id,
      test_id: this.$route.query.test_id,
      recordList: [], //考试报告列表
    };
  },
  async created() {
    await this.getTestReport(this.id);
  },
  methods: {
    //获取考试报告详情
    async getTestReport(report_id) {
      const res = await this.$http.get('/api/app/testDetail/getTestReport', {
        report_id: report_id,
      });

      this.testInfo = res;
    },
  },
};
</script>

<style scoped lang="scss">
.NewReport {
  margin-bottom: 40px;
  .main-content {
    //background: rgba(255, 255, 255, 1);
    //border-radius: 5px;
    padding: 24px 24px 56px 24px;
    margin-bottom: 30px;
    .test-info-content {
      position: relative;
      background: rgba(255, 255, 255, 1);
      border-radius: 5px;
      margin-bottom: 16px;
      padding: 32px 38px 25px 41px;
      .test-title {
        font-size: 22px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        color: #333333;
        line-height: 26px;
        max-width: 920px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 10px;
      }
      .subjective {
        height: 24px;
        margin-bottom: 30px;
        img {
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin-right: 8px;
        }
        span {
          vertical-align: middle;
          line-height: 24px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: #999999;
        }
      }
      .paper-detail {
        display: flex;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        height: 28px;
        color: #666666;
        line-height: 28px;
        .record-link {
          cursor: pointer;
        }
      }
      .grade {
        font-size: 42px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        color: #ff2424;
        line-height: 30px;
        position: absolute;
        top: 32px;
        right: 61px;
        img {
          width: 61px;
          height: 24px;
        }
      }
      .status-icon {
        position: absolute;
        top: 115px;
        right: 38px;
        img {
          width: 92px;
          height: 32px;
        }
      }
    }
    .test-result-content {
      padding: 32px 40px 44px 40px;
      background: #ffffff;
      border-radius: 8px;
      .result {
        display: flex;
        justify-content: space-between;
        .result-left {
          flex-wrap: wrap;
          width: 360px;
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          label {
            display: inline-block;
            color: #999;
            //line-height: 28px;
            height: 30px;
            line-height: 30px;
          }
          .result-grade {
            display: inline-block;
            color: #666666;
            height: 30px;
            line-height: 30px;
          }
          .result-left-info {
            width: 180px;
            margin-bottom: 10px;
            &:last-child {
              margin: 0;
            }
          }
        }
        .result-right {
          display: flex;
          .result-status {
            display: flex;
            .status-info {
              //margin-right: 50px;
              font-size: 32px;
              font-family: PingFang SC, PingFang SC-Semibold;
              font-weight: 600;
              text-align: center;
              line-height: 40px;
              height: 40px;
              vertical-align: middle;
              .status-1 {
                color: #1dcc66;
              }
              .status-2 {
                color: #ff2424;
              }
              .status-3 {
                color: #ffc109;
              }
              .status-4 {
                color: #000;
              }
              .label {
                height: 24px;
                font-size: 14px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                color: #333333;
                line-height: 24px;
                vertical-align: middle;
              }
            }
            .divider {
              width: 1px;
              height: 44px;
              opacity: 0.1;
              border-right: 1px solid #000000;
              margin: 0 50px;
              vertical-align: middle;
              position: relative;
              top: 10px;
            }
          }
        }
      }
      .footer-button {
        margin-top: 25px;
        display: flex;
        .footer-button-primary {
          width: 120px;
          height: 42px;
          background: $primary-color;
          border-radius: 22px;
          cursor: pointer;

          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          text-align: center;
          color: #fff;
          line-height: 42px;
          margin-right: 12px;
        }
        .footer-button-default {
          width: 120px;
          height: 40px;
          border: 1px solid #fc5623;
          border-radius: 22px;
          cursor: pointer;

          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          text-align: center;
          line-height: 40px;
          color: #fc5623;
        }
      }
    }
  }
  .course-cert-view {
    ::v-deep {
      .el-dialog {
        width: auto;
        text-align: center;
        background: transparent;
        box-shadow: none;
      }
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 0;
      }
    }
    .course-cert-view_img {
      max-width: 800px;
      max-height: 720px;
    }
    .course-cert-view_close {
      position: absolute;
      width: 32px;
      margin-left: 12px;
      margin-top: -44px;
      cursor: pointer;
    }
  }
}
</style>
